import React from "react";
import { useSelector } from "react-redux";
import OnboardingFlow from "../../components/onboarding/OnboardingFlow";

const OnboardingPage = () => {
  const { user } = useSelector((state) => state);

  return <OnboardingFlow user={user} role="client" />;
};

export default OnboardingPage;
